// extracted by mini-css-extract-plugin
module.exports = {"codeBlock":"blog-post-module--codeBlock--1VmOl"};